import type { PreviewEnvironmentManagerRuntime } from '../runtime.js';
import { StreamTail } from '../stream-tail.js';

export function registerPreviewEnvironmentCapture(
  runtime: PreviewEnvironmentManagerRuntime,
  environmentId: string,
  title: string,
  pipedStdoutStderr: boolean,
  mergedLogPath?: string,
  mergedCleanupDir?: string,
): { stdoutTail: StreamTail; stderrTail: StreamTail } {
  const { state, log } = runtime;

  if (!pipedStdoutStderr) {
    log(`[preview-environment] ${title} running (inherited stdio; bridge log preview disabled)`);
  } else if (mergedLogPath && mergedCleanupDir) {
    log(
      `[preview-environment] ${title} running (logs captured via temp file; open the browser log viewer for live output)`,
    );
  }

  state.pipedCaptureByServerId.set(environmentId, pipedStdoutStderr);
  const stdoutTail = new StreamTail();
  const stderrTail = new StreamTail();
  state.streamTailsByServerId.set(environmentId, { stdout: stdoutTail, stderr: stderrTail });
  if (mergedLogPath && mergedCleanupDir) {
    state.mergedLogCleanupDirByServerId.set(environmentId, mergedCleanupDir);
  }

  return { stdoutTail, stderrTail };
}
